var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacyPolicyHero1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 540,
    height: 340,
    viewBox: "0 0 540 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_297)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_201_297",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 540,
    height: 340
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M540 0H0V340H540V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_201_297)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_201_297",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 217,
    width: 92,
    height: 123
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51 225C51 220.582 54.5817 217 59 217H135C139.418 217 143 220.582 143 225V340H51V225Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_201_297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.273 339.873V217H81.4199V339.873H112.273Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.7094 314.498C93.344 314.498 91.4265 316.409 91.4265 318.766C91.4265 321.124 93.344 323.035 95.7094 323.035C98.0747 323.035 99.9922 321.124 99.9922 318.766C99.9922 316.409 98.0747 314.498 95.7094 314.498ZM88.3599 318.766C88.3599 314.721 91.6504 311.441 95.7094 311.441C99.7684 311.441 103.059 314.721 103.059 318.766C103.059 322.812 99.7684 326.091 95.7094 326.091C91.6504 326.091 88.3599 322.812 88.3599 318.766Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.5732 241.073C88.5732 240.229 89.2597 239.545 90.1065 239.545H102.414C103.261 239.545 103.948 240.229 103.948 241.073C103.948 241.917 103.261 242.601 102.414 242.601H90.1065C89.2597 242.601 88.5732 241.917 88.5732 241.073Z",
    fill: "#DC9FAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.5732 247.374C88.5732 246.53 89.2597 245.846 90.1065 245.846H102.414C103.261 245.846 103.948 246.53 103.948 247.374C103.948 248.218 103.261 248.902 102.414 248.902H90.1065C89.2597 248.902 88.5732 248.218 88.5732 247.374Z",
    fill: "#DC9FAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.5732 253.675C88.5732 252.831 89.2597 252.147 90.1065 252.147H102.414C103.261 252.147 103.948 252.831 103.948 253.675C103.948 254.519 103.261 255.203 102.414 255.203H90.1065C89.2597 255.203 88.5732 254.519 88.5732 253.675Z",
    fill: "#DC9FAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.187 339.873V217H112.333V339.873H143.187Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.623 314.498C124.258 314.498 122.34 316.409 122.34 318.766C122.34 321.124 124.258 323.035 126.623 323.035C128.988 323.035 130.906 321.124 130.906 318.766C130.906 316.409 128.988 314.498 126.623 314.498ZM119.273 318.766C119.273 314.721 122.564 311.441 126.623 311.441C130.682 311.441 133.972 314.721 133.972 318.766C133.972 322.812 130.682 326.091 126.623 326.091C122.564 326.091 119.273 322.812 119.273 318.766Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.295 267.286C119.295 266.442 119.981 265.757 120.828 265.757H133.137C133.983 265.757 134.67 266.442 134.67 267.286C134.67 268.13 133.983 268.814 133.137 268.814H120.828C119.981 268.814 119.295 268.13 119.295 267.286Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.295 234.772C119.295 233.928 119.981 233.244 120.828 233.244H133.137C133.983 233.244 134.67 233.928 134.67 234.772C134.67 235.616 133.983 236.3 133.137 236.3H120.828C119.981 236.3 119.295 235.616 119.295 234.772Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.295 273.587C119.295 272.743 119.981 272.058 120.828 272.058H133.137C133.983 272.058 134.67 272.743 134.67 273.587C134.67 274.431 133.983 275.115 133.137 275.115H120.828C119.981 275.115 119.295 274.431 119.295 273.587Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.295 279.888C119.295 279.044 119.981 278.36 120.828 278.36H133.137C133.983 278.36 134.67 279.044 134.67 279.888C134.67 280.732 133.983 281.416 133.137 281.416H120.828C119.981 281.416 119.295 280.732 119.295 279.888Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8537 340V217.127H51V340H81.8537Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.8999 340.023V217H82.4332V340.023H80.8999Z",
    fill: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.567 340.023V217H113.1V340.023H111.567Z",
    fill: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.31 281.624V230.523C104.31 228.835 102.937 227.466 101.244 227.466H90.8132C89.1196 227.466 87.7466 228.835 87.7466 230.523V281.624C87.7466 283.312 89.1196 284.68 90.8132 284.68H101.244C102.937 284.68 104.31 283.312 104.31 281.624Z",
    fill: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.224 281.62V230.519C135.224 228.831 133.851 227.462 132.157 227.462H121.726C120.033 227.462 118.66 228.831 118.66 230.519V281.62C118.66 283.308 120.033 284.676 121.726 284.676H132.157C133.851 284.676 135.224 283.308 135.224 281.62Z",
    fill: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8903 281.747V230.646C73.8903 228.958 72.5173 227.589 70.8237 227.589H60.3928C58.6992 227.589 57.3262 228.958 57.3262 230.646V281.747C57.3262 283.435 58.6992 284.803 60.3928 284.803H70.8237C72.5173 284.803 73.8903 283.435 73.8903 281.747Z",
    fill: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.306 290.902V288.603C104.306 287.759 103.62 287.075 102.773 287.075H89.2755C88.4287 287.075 87.7422 287.759 87.7422 288.603V290.902C87.7422 291.746 88.4287 292.431 89.2755 292.431H102.773C103.62 292.431 104.306 291.746 104.306 290.902Z",
    fill: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.224 290.902V288.603C135.224 287.759 134.537 287.074 133.69 287.074H120.193C119.346 287.074 118.66 287.759 118.66 288.603V290.902C118.66 291.746 119.346 292.431 120.193 292.431H133.69C134.537 292.431 135.224 291.746 135.224 290.902Z",
    fill: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8904 291.025V288.726C73.8904 287.882 73.2039 287.197 72.357 287.197H58.8595C58.0127 287.197 57.3262 287.882 57.3262 288.726V291.025C57.3262 291.869 58.0127 292.553 58.8595 292.553H72.357C73.2039 292.553 73.8904 291.869 73.8904 291.025Z",
    fill: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2894 314.625C62.9241 314.625 61.0066 316.536 61.0066 318.893C61.0066 321.251 62.9241 323.162 65.2894 323.162C67.6548 323.162 69.5723 321.251 69.5723 318.893C69.5723 316.536 67.6548 314.625 65.2894 314.625ZM57.9399 318.893C57.9399 314.848 61.2304 311.568 65.2894 311.568C69.3485 311.568 72.6389 314.848 72.6389 318.893C72.6389 322.939 69.3485 326.218 65.2894 326.218C61.2304 326.218 57.9399 322.939 57.9399 318.893Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9614 267.413C57.9614 266.569 58.6479 265.885 59.4948 265.885H71.8031C72.6499 265.885 73.3364 266.569 73.3364 267.413C73.3364 268.257 72.6499 268.941 71.8031 268.941H59.4948C58.6479 268.941 57.9614 268.257 57.9614 267.413Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9614 234.899C57.9614 234.055 58.6479 233.371 59.4948 233.371H71.8031C72.6499 233.371 73.3364 234.055 73.3364 234.899C73.3364 235.743 72.6499 236.427 71.8031 236.427H59.4948C58.6479 236.427 57.9614 235.743 57.9614 234.899Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9614 273.714C57.9614 272.87 58.6479 272.186 59.4948 272.186H71.8031C72.6499 272.186 73.3364 272.87 73.3364 273.714C73.3364 274.558 72.6499 275.242 71.8031 275.242H59.4948C58.6479 275.242 57.9614 274.558 57.9614 273.714Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9614 280.015C57.9614 279.171 58.6479 278.487 59.4948 278.487H71.8031C72.6499 278.487 73.3364 279.171 73.3364 280.015C73.3364 280.859 72.6499 281.543 71.8031 281.543H59.4948C58.6479 281.543 57.9614 280.859 57.9614 280.015Z",
    fill: "#B0BEC5"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M490.139 243.653C486.531 241.721 483.471 242.652 480.073 246.229C481.625 237.54 481.573 227.001 474.683 225.227C467.588 223.393 463.567 227.811 459.408 238.489C459.566 229.326 457.754 217.509 450.167 217.029C441.635 216.489 438.815 223.506 436.696 239.07C434.044 230.365 426.72 215.12 418.113 218.143C409.674 221.102 410.218 229.236 414.906 245.821C410.282 238.661 401.03 228.018 394.838 232.064C388.946 235.905 390.558 242.164 397.088 253.794C392.779 251.919 388.297 251.735 384.712 255.275C376.663 263.226 380.534 270.757 391.702 284.735C402.871 298.712 483.099 273.986 486.906 267.663C490.713 261.34 496.694 247.156 490.139 243.653Z",
    stroke: "#ECEFF1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M490.769 267.402L490.833 267.195L382.949 267.529L383.017 267.735C380.187 268.287 377.681 269.913 376.025 272.272C374.368 274.631 373.69 277.541 374.132 280.389L382.207 332.437L491.575 332.103L499.654 280.055C500.095 277.207 499.416 274.298 497.76 271.939C496.103 269.58 493.598 267.954 490.769 267.402Z",
    fill: "#ECEFF1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M172.994 313.058C69.6433 284.472 65.1918 206.908 65 103.555C64.9836 94.685 69.2162 86.2466 76.6774 81.2268C118.19 53.2969 157.651 39.6864 173.124 35.0202C177.635 33.6599 182.365 33.6599 186.876 35.0202C202.349 39.6864 241.81 53.2969 283.323 81.2268C290.784 86.2467 295.016 94.685 295 103.555C294.808 206.908 290.357 284.472 187.007 313.058C182.465 314.314 177.536 314.314 172.994 313.058Z",
    fill: "#ECEFF1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M174.784 294.285C131.132 281.963 108.716 259.269 96.9828 228.699C85.1154 197.779 84.0828 158.617 84 113.103C83.9875 106.234 87.1981 99.7779 92.7508 95.9652C128.153 71.6569 161.815 59.8101 174.963 55.7636C178.271 54.7455 181.729 54.7455 185.037 55.7636C198.185 59.8101 231.847 71.6569 267.249 95.9652C272.802 99.778 276.012 106.234 276 113.103C275.917 158.617 274.885 197.779 263.018 228.699C251.284 259.269 228.869 281.963 185.217 294.285C181.84 295.238 178.161 295.238 174.784 294.285Z",
    fill: "#F2F4F8",
    stroke: "#100C41",
    strokeWidth: 6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M185.234 75.4665C185.234 70.9781 181.86 66.9427 177.653 68.2495C166.112 71.8354 136.677 82.295 105.711 103.759C100.145 107.616 96.9878 114.101 97 120.917C97.0278 136.318 97.175 150.974 97.9563 164.755C98.5325 174.918 106.948 182.56 116.92 182.56H185.234V279.594C185.234 281.129 186.56 282.331 188.009 281.918C234.647 268.628 254.286 241.564 262.556 204.669C265.167 193.02 255.895 182.56 244.189 182.56H185.234V75.4665Z",
    fill: "#B0BEC5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M241 177C241 143.863 214.137 117 181 117C147.863 117 121 143.863 121 177C121 210.137 147.863 237 181 237C214.137 237 241 210.137 241 177Z",
    fill: "#B0BEC5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M237 171C237 138.415 210.585 112 178 112C145.415 112 119 138.415 119 171C119 203.585 145.415 230 178 230C210.585 230 237 203.585 237 171Z",
    fill: "white",
    stroke: "#B0BEC5",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.5 141C169.34 141 164.286 146.133 164.286 151.586V161.357H156.143V151.586C156.143 140.85 165.671 132.857 176.5 132.857C187.329 132.857 196.857 140.85 196.857 151.586V161.357H188.714V151.586C188.714 146.133 183.66 141 176.5 141Z",
    fill: "#00B6A4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M153.429 170.857C153.429 166.36 157.074 162.715 161.572 162.715H194.143C198.64 162.715 202.286 166.36 202.286 170.857V195.286C202.286 199.783 198.64 203.429 194.143 203.429H161.572C157.074 203.429 153.429 199.783 153.429 195.286V170.857Z",
    fill: "#00B6A4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148 169.5C148 162.754 153.469 157.286 160.214 157.286H192.786C199.531 157.286 205 162.754 205 169.5V193.929C205 200.675 199.531 206.143 192.786 206.143H160.214C153.469 206.143 148 200.675 148 193.929V169.5ZM160.214 165.429C157.966 165.429 156.143 167.252 156.143 169.5V193.929C156.143 196.177 157.966 198 160.214 198H192.786C195.034 198 196.857 196.177 196.857 193.929V169.5C196.857 167.252 195.034 165.429 192.786 165.429H160.214Z",
    fill: "#00B6A4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M176.5 189.858C180.997 189.858 184.643 186.212 184.643 181.715C184.643 177.218 180.997 173.572 176.5 173.572C172.003 173.572 168.357 177.218 168.357 181.715C168.357 186.212 172.003 189.858 176.5 189.858Z",
    fill: "#F2F4F8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M397.246 126.353C395.44 107 384.604 106.078 362.933 103.313L357.516 156.766L383.702 168.746C388.818 161.066 398.691 141.836 397.246 126.353Z",
    fill: "#100C41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M224.604 335.583L237.638 249.666L268.52 235.047L272.454 283.299L288.343 232.134L295.149 313.963L286.888 343.254C272.454 371.195 226.468 370.226 224.604 335.583Z",
    fill: "#3ECF7A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M269.589 255.649L274.701 308.813",
    stroke: "#100C41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M360.642 210.407C309.283 215.071 288 237.242 288 237.242C276.149 271.423 278.121 283.709 293.882 313.942L299.35 343.317H435.217L440 242.742C440 242.742 412 205.742 360.642 210.407Z",
    fill: "#3ECF7A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M417 297.5C416.148 288.628 415.219 283.885 412.5 276",
    stroke: "#100C41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M316.943 178.285C322.138 177.694 325.761 172.041 325.036 165.659C324.31 159.276 319.51 154.581 314.315 155.171C309.12 155.762 305.496 161.415 306.222 167.797C306.948 174.18 311.748 178.875 316.943 178.285Z",
    fill: "white",
    stroke: "#100C41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M321.731 178.97C315.936 172.498 304.794 156.737 306.589 145.476C311.636 144.019 321.731 140.913 321.731 140.136V178.97Z",
    fill: "#100C41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M384.624 174.814C389.775 175.715 394.9 171.017 396.072 164.32C397.244 157.623 394.018 151.463 388.868 150.562C383.717 149.661 378.592 154.359 377.42 161.056C376.248 167.753 379.474 173.913 384.624 174.814Z",
    fill: "white",
    stroke: "#100C41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M379.336 162.278C389.122 158.493 393.982 147.638 395.189 142.683L382.98 134.961C377.687 145.644 369.549 166.063 379.336 162.278Z",
    fill: "#100C41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M342.399 221.703L343.23 202.794C343.587 194.672 349.978 188.109 358.087 187.536L372.981 186.484L378.033 219.731C379.437 228.968 372.662 237.437 363.342 238.095L359.51 238.366C349.974 239.04 341.979 231.254 342.399 221.703Z",
    fill: "white",
    stroke: "#100C41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M348.313 206.574C366.946 206.574 382.052 185.289 382.052 159.033C382.052 132.777 366.946 111.492 348.313 111.492C329.68 111.492 314.574 132.777 314.574 159.033C314.574 185.289 329.68 206.574 348.313 206.574Z",
    fill: "white",
    stroke: "#100C41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M377 181.5C371.269 196.009 360.688 205.905 348.141 205.905C339.701 205.905 332.388 201.321 326.5 194C331.178 189.468 339.188 185.218 349.277 182.493C360.638 179.424 370.85 179.175 377 181.5Z",
    fill: "#D5DDE8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M346.602 182.384L340.958 183.632C340.821 183.662 340.68 183.662 340.543 183.63C340.407 183.599 340.28 183.537 340.171 183.449C340.062 183.361 339.974 183.25 339.914 183.124C339.854 182.997 339.823 182.859 339.823 182.719L339.926 166.41",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M346.602 182.384L340.958 183.632C340.821 183.662 340.68 183.662 340.543 183.63C340.407 183.599 340.28 183.537 340.171 183.449C340.062 183.361 339.974 183.25 339.914 183.124C339.854 182.997 339.823 182.859 339.823 182.719L339.926 166.41",
    stroke: "#100C41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M358.881 151.704C358.881 151.704 352.629 148.827 349.684 153.745L358.881 151.704Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M358.881 151.704C358.881 151.704 352.629 148.827 349.684 153.745",
    stroke: "#100C41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M334.364 153.213C334.364 153.213 327.769 150.884 325.216 155.937L334.364 153.213Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M334.364 153.213C334.364 153.213 327.769 150.884 325.216 155.937",
    stroke: "#100C41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M354.085 167.77C353.987 165.863 352.872 164.37 351.594 164.435C350.317 164.5 349.359 166.099 349.457 168.006C349.554 169.914 350.669 171.407 351.947 171.342C353.225 171.277 354.182 169.678 354.085 167.77Z",
    fill: "#100C41"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M335.761 170.07C335.865 168.155 334.918 166.547 333.645 166.477C332.371 166.408 331.255 167.904 331.15 169.818C331.046 171.733 331.993 173.341 333.266 173.411C334.539 173.48 335.656 171.984 335.761 170.07Z",
    fill: "#100C41"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M359.39 185.104C352.88 188.563 348.964 189.909 341.156 191.37C342.025 192.995 345.498 195.687 352.444 193.459C359.39 191.231 359.968 186.961 359.39 185.104Z",
    fill: "white",
    stroke: "#100C41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M274.46 288.365C272.931 288.365 271.536 287.494 270.865 286.12L225.368 192.903C224.071 190.246 226.006 187.149 228.963 187.149H289.4C290.93 187.149 292.327 188.022 292.997 189.399L338.358 282.615C339.651 285.272 337.716 288.365 334.762 288.365H274.46Z",
    fill: "#B2CDFC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M245.652 285.898C246.239 287.101 247.46 287.865 248.799 287.865H326.589C329.173 287.865 330.866 285.161 329.737 282.836L284.47 189.62L284.92 189.402L284.47 189.62C283.885 188.415 282.662 187.649 281.322 187.649H203.397C200.811 187.649 199.118 190.356 200.25 192.681L245.652 285.898ZM245.652 285.898C245.652 285.898 245.652 285.898 245.652 285.898L200.25 192.681L245.652 285.898Z",
    fill: "white",
    stroke: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M262.29 245.677C261.397 244.785 261.397 243.337 262.29 242.445L273.065 231.67C273.957 230.777 275.405 230.777 276.297 231.67C277.19 232.563 277.19 234.01 276.297 234.902L265.522 245.677C264.63 246.57 263.183 246.57 262.29 245.677Z",
    fill: "#B2CDFC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M258.017 241.405C257.125 240.512 257.125 239.065 258.017 238.172L263.405 232.785C264.297 231.892 265.745 231.892 266.637 232.785C267.53 233.677 267.53 235.125 266.637 236.017L261.25 241.405C260.357 242.297 258.91 242.297 258.017 241.405Z",
    fill: "#B2CDFC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M253.669 237.057C252.777 236.164 252.777 234.717 253.669 233.824L255.824 231.669C256.717 230.777 258.164 230.777 259.057 231.669C259.95 232.562 259.95 234.009 259.057 234.902L256.902 237.057C256.009 237.95 254.562 237.95 253.669 237.057Z",
    fill: "#B2CDFC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M318.056 261.526H333.083L348.313 282.165L331.353 303.444C323.072 298.66 307.847 289.302 297.728 281.119C293.722 277.879 290.716 265.995 292.72 261.526H318.056Z",
    fill: "white",
    stroke: "#100C41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M327.516 252.036C329.281 253.589 329.671 254.969 334 262.474L325.011 264.851C326.3 263.072 326.399 258.265 325.011 254.775C324.199 252.735 325.864 250.582 327.516 252.036Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M334 262.742C329.671 255.009 329.482 253.833 327.717 252.233C326.066 250.734 324.401 252.954 325.212 255.055C326.601 258.652 326.789 259.909 325.5 261.742",
    stroke: "#100C41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M289.311 268.403C291.472 272.845 294.414 278.218 297.269 280.672L292.924 265.056C292.924 265.056 289.643 260.232 288.317 256.134C286.991 252.037 286.808 250 286.327 250C285.847 250 284.338 255.112 285.332 258.179C286.327 261.246 287.322 264.313 289.311 268.403Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M297.269 280.672C294.414 278.218 291.472 272.845 289.311 268.403C287.322 264.313 286.327 261.246 285.332 258.179C284.338 255.112 285.847 250 286.327 250C286.808 250 286.991 252.037 288.317 256.134C289.643 260.232 292.924 265.056 292.924 265.056",
    stroke: "#100C41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M298.158 273.569L298.256 273.699L302.6 269.764L293.541 252.615C293.541 252.615 291.1 246.465 290.274 243.833C289.447 241.201 286.963 237.669 284.403 237.625C281.842 237.581 282.636 241.087 283.461 242.846C284.286 244.605 287.537 254.26 289.994 260.41C291.939 265.278 295.133 269.536 298.158 273.569Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M298.256 273.699C295.202 269.628 291.96 265.33 289.994 260.41C287.537 254.26 284.286 244.605 283.461 242.846C282.636 241.087 281.842 237.581 284.403 237.625C286.963 237.669 289.447 241.201 290.274 243.833C291.1 246.465 293.541 252.615 293.541 252.615",
    stroke: "#100C41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M294.067 254.303C296.033 259.223 299.394 265.14 303.272 269.435L310.428 266.413C302.446 263.577 295.374 241.041 294.346 237.725C293.318 234.41 291.035 231.562 288.475 231.518C285.915 231.474 286.708 234.98 287.533 236.738C288.358 238.497 291.609 248.152 294.067 254.303Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M303.272 269.435C299.394 265.14 296.033 259.223 294.067 254.303C291.609 248.152 288.358 238.497 287.533 236.738C286.708 234.98 285.915 231.474 288.475 231.518C291.035 231.562 293.318 234.41 294.346 237.725C295.374 241.041 302.446 263.577 310.428 266.413",
    stroke: "#100C41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M304.244 258.374C305.252 260.897 307.983 264.482 311.068 267.152L319.247 262.546C312.398 260.531 305.908 244.911 304.524 241.797C303.14 238.683 301.213 235.633 298.653 235.589C296.092 235.545 296.886 239.051 297.711 240.81C298.536 242.569 301.787 252.224 304.244 258.374Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M311.068 266.894C307.983 264.224 305.252 260.639 304.244 258.116C301.787 251.966 298.536 242.311 297.711 240.552C296.886 238.793 296.092 235.287 298.653 235.331C301.213 235.375 303.14 238.425 304.524 241.539C305.908 244.653 311.569 259.82 318.418 261.834",
    stroke: "#100C41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M299.42 144.002C321.878 157.573 365.897 135.861 366.795 122.29L374.881 106.006C375.18 101.482 370.664 94.5302 363.202 91.5288C359.609 90.0834 351.524 90.6255 348.829 95.1491C347.631 93.6412 336.952 86.7891 315.589 89.7219C276.061 95.1487 276.961 130.431 299.42 144.002Z",
    fill: "#100C41"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M385 149.29C368.929 154.02 357.571 133.919 355 124.459L378.571 115L385 149.29Z",
    fill: "#100C41"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M472.5 323.242C469.5 292.742 459.5 265.242 440 242.742L435 302.242C417 297.242 376.5 286.042 358.5 281.242C336 275.242 323 309.242 332 315.242C341 321.242 412.5 365.742 437 366.742C461.5 367.742 475.5 353.742 472.5 323.242Z",
    fill: "#3ECF7A"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M437 367C412.5 366 341 321.5 332 315.5C323 309.5 336 275.5 358.5 281.5C376.5 286.3 417 297.5 435 302.5",
    stroke: "#100C41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M536 332H4C1.79086 332 0 333.791 0 336C0 338.209 1.79086 340 4 340H536C538.209 340 540 338.209 540 336C540 333.791 538.209 332 536 332Z",
    fill: "#ECEFF1"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M448.257 111C459.303 111 468.257 102.046 468.257 91C468.257 79.9543 459.303 71 448.257 71C437.211 71 428.257 79.9543 428.257 91C428.257 95.3926 429.673 99.4545 432.073 102.754L424.359 109.234C423.644 109.835 424.069 111 425.002 111H447.257V110.975C447.588 110.992 447.921 111 448.257 111Z",
    fill: "#8D9DB5"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M446.257 108C457.303 108 466.257 99.0457 466.257 88C466.257 76.9543 457.303 68 446.257 68C435.211 68 426.257 76.9543 426.257 88C426.257 92.3926 427.673 96.4545 430.073 99.754L422.359 106.234C421.644 106.835 422.069 108 423.002 108H445.257V107.975C445.588 107.992 445.921 108 446.257 108Z",
    fill: "white",
    stroke: "#8D9DB5",
    strokeWidth: 2
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M446.257 78C440.737 78 436.257 82.48 436.257 88C436.257 93.52 440.737 98 446.257 98C451.777 98 456.257 93.52 456.257 88C456.257 82.48 451.777 78 446.257 78ZM445.256 95.9304C441.306 95.4404 438.256 92.0804 438.256 88.0004C438.256 87.3804 438.336 86.7904 438.466 86.2104L443.256 91.0004V92.0004C443.256 93.1004 444.156 94.0004 445.256 94.0004V95.9304ZM452.157 93.3903C451.897 92.5803 451.157 92.0003 450.257 92.0003H449.257V89.0003C449.257 88.4503 448.807 88.0003 448.257 88.0003H442.257V86.0003H444.257C444.807 86.0003 445.257 85.5503 445.257 85.0003V83.0003H447.257C448.357 83.0003 449.257 82.1003 449.257 81.0003V80.5903C452.187 81.7803 454.257 84.6503 454.257 88.0003C454.257 90.0803 453.457 91.9703 452.157 93.3903Z",
    fill: "#7D50FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 540,
    height: 340,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPolicyHero1);
export default __webpack_public_path__ + "static/media/privacy_policy_hero 1.4ac7745b4919071c7a78acdf8a29798e.svg";
export { ForwardRef as ReactComponent };